import React from "react";
import { Box, Container, Typography, Button, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Image from "../Images/UlapRecPictures/1.jpg";

const useStyles = makeStyles((theme) => ({
    heroContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: theme.spacing(12.5),
        paddingBottom: theme.spacing(12.5),
        flexDirection: "row",
        [theme.breakpoints.down("md")]: { 
            flexDirection: "row",
            paddingTop: theme.spacing(7.5),
            paddingBottom: theme.spacing(7.5),
        },
        [theme.breakpoints.down("sm")]: { 
            flexDirection: "column",
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(6.25),
        },
    },
    textContainer: {
        flex: 1,
        marginRight: theme.spacing(2.5),
        [theme.breakpoints.down("md")]: { 
            marginRight: theme.spacing(1.25),
            marginBottom: theme.spacing(2.5),
            textAlign: "left", 
        },
        [theme.breakpoints.down("sm")]: { 
            marginRight: 0,
            marginBottom: theme.spacing(2),
            textAlign: "left",
        },
    },
    title: {
        fontSize: "40px",
        fontWeight: "bold",
        // color: "#FF7707",
        lineHeight: 1.1, 
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down("md")]: { 
            paddingTop: theme.spacing(2.5),
            fontSize: "32px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(2.5),
            fontSize: "30px",
        },
    },
    image: {
        flex: 1,
        maxWidth: "40%",
        height: "auto",
        marginLeft: "250px",
        [theme.breakpoints.down("md")]: { 
            maxWidth: "40%", 
            marginLeft: "200px",
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
            margin: "0 auto", 
        },
    },
    description: {
        fontSize: "20px",
        textAlign: "left",
        [theme.breakpoints.down("md")]: { 
            fontSize: "17px",
        },
        [theme.breakpoints.down("sm")]: { 
            textAlign: "justify",
            fontSize: "16px",
        },
    },
    highlight: {
        color: "#FF7707",
    },
}));

function GoingBeyond() {
    const classes = useStyles();


    return (
            <Container className={classes.heroContainer}>
            
                <Box className={classes.textContainer}>
                    <Typography className={classes.title}>MORE THAN JUST <span className={classes.highlight}>HIRING AUTOMATION</span></Typography>
                    <Typography className={classes.description}>
                    UlapRecruit doesn’t just fill roles—it builds stronger teams.
                    With continuous learning tools and onboarding, your employees stay engaged, skilled, and productive.
                    </Typography>
                </Box>
                <img src={Image} alt="Image" className={classes.image} />
            </Container>
    );
}

export default GoingBeyond;
